import { useQuery } from '@tanstack/react-query';
import { getWorkEnvironmentSurveysByTeamId } from '../../api/workEnvironmentQueries';

export const WorkEnvironmentSurveysByTeamIdQueryKey = 'WORK_ENVIRONMENT_SURVEYS_BY_TEAM_ID';

export const useGetWorkEnvironmentSurveysByTeamIdQuery = (teamId: number) => {
  return useQuery({
    queryKey: [WorkEnvironmentSurveysByTeamIdQueryKey, teamId],
    queryFn: () => getWorkEnvironmentSurveysByTeamId(teamId),
    enabled: !!teamId,
  });
};